export default __webpack_public_path__ + "static/column-with-negative-values-d1f3f495657723c0464ca8a5a6bf8ac1.png";